/**
 * Zwergenwald - Groessenwahl als Auswahlkarten (blocks/zw-variantenkarten.liquid, O-93).
 *
 * Die Karten sind eigene Radio-Felder (Tastatur und Screenreader wie bei jeder Radio-Gruppe).
 * Beim Wechsel klickt das Modul das gleichwertige Feld in Horizons <variant-picker> - erkannt an
 * data-option-value-id. Horizon hoert dort auf "change" (assets/variant-picker.js), laedt die
 * Seite fuer die neue Variante und gleicht Preis, Bild und Kaufknopf an. Eigene Kauflogik gibt
 * es hier nicht. Horizons Auswahl ist per CSS ausgeblendet, solange Karten da sind.
 *
 * Wie ein React-Wrapper um eine fremde Komponente: Die Karten sind die Oberflaeche, der Zustand
 * bleibt bei Horizon.
 */
class ZwVariantenkarten extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#beiWechsel);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#beiWechsel);
  }

  /** @param {Event} event */
  #beiWechsel = (event) => {
    const karte = event.target;
    if (!(karte instanceof HTMLInputElement) || karte.type !== 'radio') return;

    const id = karte.dataset.optionValueId;
    if (!id) return;

    const bereich = this.closest('dialog, .shopify-section') ?? document;
    const ziel = bereich.querySelector(
      `variant-picker input[type="radio"][data-option-value-id="${CSS.escape(id)}"]`
    );
    if (ziel instanceof HTMLInputElement && !ziel.checked) ziel.click();
  };
}

if (!customElements.get('zw-variantenkarten')) {
  customElements.define('zw-variantenkarten', ZwVariantenkarten);
}

/**
 * Knoepfe mit data-zw-waehle-wert (z. B. "3er-Set ansehen" in zw-set-ersparnis, spaeter das
 * Ergebnis des Passform-Checks) waehlen eine Groesse: gleicher Weg wie die Karten, danach springt
 * die Seite zur Groessenwahl. Einmal pro Seite registriert (Modul wird nur einmal ausgefuehrt).
 */
document.addEventListener('click', (event) => {
  const knopf = event.target instanceof Element ? event.target.closest('[data-zw-waehle-wert]') : null;
  if (!(knopf instanceof HTMLElement)) return;

  const id = knopf.dataset.zwWaehleWert;
  if (!id) return;

  const bereich = knopf.closest('dialog, .shopify-section') ?? document;
  const ziel =
    bereich.querySelector(`variant-picker input[type="radio"][data-option-value-id="${CSS.escape(id)}"]`) ??
    document.querySelector(`variant-picker input[type="radio"][data-option-value-id="${CSS.escape(id)}"]`);
  if (!(ziel instanceof HTMLInputElement)) return;

  event.preventDefault();
  if (!ziel.checked) ziel.click();
  const anker = document.querySelector('zw-variantenkarten') ?? ziel.closest('variant-picker');
  anker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
